import {IUserStatistic} from '@/stores/ItemsStore/ItemsStore.types';

import {StatisticValidationRule} from '@/resources';
import {FrontendError} from '@/services/ErrorService/FrontendError';
import {StatisticItemValidationType} from '@/types';

import {validateBlackListString} from './validateBlackListString';
import {validateDayMonthDate} from './validateDayMonthDate';
import {validateIntegerNumber} from './validateIntegerNumber';
import {validateLessThanValueNumber} from './validateLessThanValueNumber';
import {validateMaxStringLength} from './validateMaxStringLength';
import {validateMinStringLength} from './validateMinStringLength';
import {validateMonthDate} from './validateMonthDate';
import {validateMoreThanValueNumber} from './validateMoreThanValueNumber';
import {validateNonNegativeNumber} from './validateNonNegativeNumber';
import {validateRoundNumber} from './validateRoundNumber';
import {validateSeconds} from './validateSeconds';
import {validateSignsAfterCommaInNumber} from './validateSignsAfterCommaInNumber';
import {validateUpperCaseString} from './validateUpperCaseString';
import {validateWhiteListNumber} from './validateWhiteListNumber';

type ValidationCb<T> = (
  statistic: IUserStatistic,
  rule: T,
  logError: (error: FrontendError) => void,
  shouldLogError?: boolean,
) => string | null;
type ValidationRules = Record<StatisticItemValidationType, ValidationCb<StatisticValidationRule>>;

export const validationRules: ValidationRules = {
  [StatisticItemValidationType.MaxStringLength]: validateMaxStringLength,
  [StatisticItemValidationType.MinStringLength]: validateMinStringLength,
  [StatisticItemValidationType.UpperCaseString]: validateUpperCaseString,
  [StatisticItemValidationType.BlackListString]: validateBlackListString,
  [StatisticItemValidationType.NonNegative]: validateNonNegativeNumber,
  [StatisticItemValidationType.Integer]: validateIntegerNumber,
  [StatisticItemValidationType.SignsAfterComma]: validateSignsAfterCommaInNumber,
  [StatisticItemValidationType.MoreThanValue]: validateMoreThanValueNumber,
  [StatisticItemValidationType.LessThanValue]: validateLessThanValueNumber,
  [StatisticItemValidationType.DayMonthDate]: validateDayMonthDate,
  [StatisticItemValidationType.MonthDate]: validateMonthDate,
  [StatisticItemValidationType.Seconds]: validateSeconds,
  [StatisticItemValidationType.WhiteListNumber]: validateWhiteListNumber,
  [StatisticItemValidationType.RoundNumber]: validateRoundNumber,
};
